<template lang="pug">
  .h-100(@dragenter.prevent="dragHandled(true)")
    b-card.my-0.mx-0.h-100.p-3.no-shadow(no-body, :style="composerStyle")
      div(
        v-if="isActive"
        @dragleave.prevent="dragHandled(false)"
        @dragover.prevent
        @drop.prevent="dropHandled($event)"
        :class="{ 'active-position': isActive }"
      ).d-flex.align-items-center.justify-content-center.flex-column.position
      b-row.flex-column.h-100.flex-nowrap
        b-col.bb-1(cols="auto")
          b-form-row.mb-3.align-items-center
            b-col.d-flex.align-items-center
              Avatar.mr-3(v-if="userData.profile_pic", size="xs", :src="userData.profile_pic", :platform="case_object.platform")
              span.d-none.d-md-block.mr-3.text-reset {{ userName }}
            b-col(cols="auto", v-if="case_object.status && case_object.status !== 'open' && $can('read', 'open-case')",)
              b-button(size="sm", variant="primary", @click="updateCase({status: 'open'})") Abrir
            b-col(cols="auto", v-if="case_object.status && case_object.status === 'open'")
              b-button(size="sm", variant="soft-primary", @click="holdCase") En espera
            b-col(cols="auto", v-if="case_object.status && case_object.status !== 'close'")
              b-button(size="sm", variant="primary", @click="close_case_modal = true") Cerrar
            b-col.d-flex.align-items-center(cols="auto")
              shopping-cart-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Orden del usuario'", @click="side_modal_cart = true", v-if="isEcommerce")
              file-text-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Historial de ordenes'", @click="side_modal_orders = true", v-if="isEcommerce")
              b-button(size="sm", variant="light", v-b-tooltip.hover="'Información del caso'", @click="$emit('click:side_modal_case_info')")
                alert-circle-icon.icon-md
            b-col(cols="auto", v-if="case_object.status && case_object.status !== 'close' && ['voip', 'whatsapp_official'].includes(case_object.platform)")
              b-button(pill size="sm", variant="primary", @click="isCallPanelOpen = !isCallPanelOpen")
                phone-call-icon.icon-sm
        b-col(
          @v-chat-scroll-top-reached="loadMoreMessages",
          v-chat-scroll="{notSmoothOnInit: false, always: true, smooth: true}"
        ).overflow-y.scrollable-area.pt-3#messages-container
          //- messages layout for cases
          time-line(
            :case_messages="caseMessages",
            :user-data="userData",
            :admins="admins",
            :viewer_options="viewer_options",
            @goToExactMessage="goToExactMessage"
          )
        b-col(cols="auto", style="white-space:nowrap;", v-if="files.length").bt-1.d-flex.scrollable-area.overflow-x
          .attachment-holder.d-inline-flex.bg-light(v-for="(file, file_index) in files", :key="file_index")
            b-img.mr-2(:src="file.src", width="30", height="30", rounded, v-if="file.type == 'image'")
            file-text-icon.mr-2.text-secondary(v-else-if="file.type == 'file'")
            div.d-flex.justify-content-center.align-items-center(v-else-if="file.type === 'audio'").mr-2
              mic-icon.text-secondary
              audio(controls, :src="file.file.src")
            div.d-flex.flex-column.text-sm
              span.text-secondary {{ file.file ? file.file.name : getFileName(file) }}
              span.text-help(v-if="file.file") {{ file.file.size/1024 >= 1024 ? (Math.round(file.file.size/1024/1024) + ' MB') : (Math.round(file.file.size/1024) + ' KB') }}
              b-link.text-danger.opacity-70(@click="files.splice(file_index, 1)", href="#") Quitar
        ScrollDownButton(id="button-to-scroll-down", element_id="messages-container", :right="'13'", :bottom="'80'", :nameIcon="'chevron-down'", :colorButton="'soft-primary'", :isScrollUp="false", :container="scrollButton", :message="lastMessage").d-flex.justify-content-end.position-absolute
        composer-input(v-if="case_object.platform !== 'voip'", :container="container", :platform="case_object.platform" :lastMessage="getLastMessage()", :user-id="userData.user_id", :isForCases="true", :files="files", @files="updateFiles($event)", @files:push="pushFiles($event)", @files:remove="removeFiles($event)")
    b-modal(v-model="close_case_modal", title="Cerrar caso", cancel-title="Cancelar", ok-title="Cerrar caso", ok-variant="danger", :ok-disabled="!can_close_case", @ok="updateCase({status: 'close'})")
      div(v-if="!can_close_case") Agrega
        b-link.mx-1(@click="close_case_modal = false; openTagsModal()") Etiquetas
        span al caso para poder cerrarlo
      div(v-else) ¿Deseas cerrar el caso?
    SideModal(size="md", padding, :value="side_modal_cart || side_modal_orders", @input="side_modal_cart = side_modal_orders = false")
      template
        conversation-cart(v-if="side_modal_cart" :conversation="conversation" :case-id="case_object.case_id")
        conversation-orders(v-if="side_modal_orders" :conversation="conversation" :case-id="case_object.case_id")
</template>

<script>
import Avatar from './Avatar.vue'
import ConversationCart from './ConversationCart.vue'
import ConversationOrders from './ConversationOrders.vue'
import ComposerInput from '@/components/ComposerInput.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import { EventBus } from '../helpers/eventBus'
import ScrollDownButton from '@/components/ScrollTopBtn.vue'
import Validators from '@/helpers/data_validators'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
import mixpanel from '@/mixpanel'

const TimeLine = () => import('./TimeLine.vue')
Vue.use(Viewer)
const accountController = createNamespacedHelpers('account')
const caseController = createNamespacedHelpers('case')
const groupController = createNamespacedHelpers('group')
const tagController = createNamespacedHelpers('tag')
const NAME_FILE_NOT_AVAILABLE = 'Nombre de archivo no disponible'

export default {
  mixins: [Validators.Methods],
  props: {
    cases: {
      default: undefined
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isCallPanelOpen: false,
      isActive: false,
      scrollButton: null,
      container: null,
      lastMessage: {},
      message: '',
      first_message_id: undefined,
      files: [],
      viewer_options: {
        navbar: false,
        toolbar: {
          zoomIn: 4,
          zoomOut: 4,
          oneToOne: 4,
          reset: 4,
          prev: 0,
          play: 0,
          next: 0,
          rotateLeft: 4,
          rotateRight: 4,
          flipHorizontal: 4,
          flipVertical: 4
        }
      },
      side_modal_cart: false,
      side_modal_orders: false,
      close_case_modal: false,
      externalId: ''
    }
  },
  computed: {
    ...caseController.mapGetters(['selectedEventTypes', 'selectedEventNames']),
    ...caseController.mapState({
      case_messages: state => state.messages,
      case_object: state => state.case_object,
      case_events_filters: state => state.case_events_filters
    }),
    ...tagController.mapState({
      tags: state => state.tags
    }),
    ...groupController.mapState({
      groups: state => state.groups
    }),
    ...accountController.mapState({
      account: state => state.account,
      admins: state => state.admins,
      force_case_tag: state => state.account_configuration.force_case_tag
    }),
    caseGroup () {
      return (this.case_object && this.case_object.Group) ? this.case_object.Group : {}
    },
    userData () {
      return (this.case_object && this.case_object.User) ? this.case_object.User : {}
    },
    userName() {
      if (Object.keys(this.userData).length) {
        if (this.userData.first_name || this.userData.last_name) {
          return `${this.userData.first_name || ''} ${this.userData.last_name || ''}`
        } else {
          return this.externalId || 'Usuario'
        }
      }

      return ''
    },
    composerStyle () {
      return this.border != undefined ? (this.border !== false ? '' : { border: 'none !important' }) : ''
    },
    isEcommerce () {
      return (new RegExp('^konverza-ecommerce', 'i')).test(this.account.type)
      // todo check ecommerce plugin
      // this.$can('read', 'ecommerce-view')
    },
    conversation () {
      if (!this.case_object || !this.case_object.User) {
        return {
          platform: ''
        }
      }
      return {
        user: this.case_object ? this.case_object.User : '',
        user_id: this.case_object && this.case_object.User ? this.case_object.User.user_id : '',
        platform: this.case_object ? this.case_object.platform : ''
      }
    },
    caseTags () {
      return this.case_object && this.case_object.Tags ? this.case_object.Tags : []
    },
    can_close_case () {
      return this.force_case_tag ? !!this.caseTags.length : true
    },
    caseMessages() {
      this.container = document.getElementById('messages-container')
      this.scrollButton = document.getElementById('button-to-scroll-down')

      if (!this.case_messages.length) return

      const indexOfLastMessage = this.case_messages.length - 1
      this.lastMessage = this.case_messages[indexOfLastMessage]

      return this.case_messages
    }
  },
  methods: {
    ...mapActions([
      'case/messages',
      'case/update',
      'account/get',
      'case/get',
      'admin/get'
    ]),
    goToExactMessage(message) {
      //this.$store.commit('inbox_filters/enableSearch', true)
      //this.$store.commit('conversation/selectMessage', message) --> Review logic

      const params = { isSearch: this.searchIsEnabled }

      this['case/messages']({
        case_id: this.$route.params.case_id,
        params,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          this.$nextTick(() => {
            const index = this.case_messages.findIndex(({ _id }) => {
              return _id === message._id
            })

            if (index >= 0) {
              const { _id: firstMessageId } = this.case_messages[index] || {}

              if (firstMessageId) {
                const container = $('#messages-container')
                const messageFound = $(
                  `#messages-container [_id=${firstMessageId}]`
                ).first()

                if (messageFound) {
                  try {
                    if (messageFound.offset().top >= 500) {
                      container.scrollTop(messageFound.offset().top - container.offset().top)
                    } else if (messageFound.offset().top <= 0) {
                      container.scrollTop(messageFound.offset().top - container.offset().top)
                    }
                  } catch (e) {

                  }
                }
              }

              this.first_message_id = firstMessageId
            }
          })
        }
      })
    },
    async getCase() {
      if (!this.$route.params.case_id) return

      const self = this

      this['case/get']({
        case_id: self.$route.params.case_id,
        params: { account_id: self.$route.params.account_id },
        soft: true,
        callback: async (res) => {
          if (res.error) return self.$message.error(res.error)

          this.externalId = res.resource.User.external_id
        }
      })
    },
    loadMoreMessages(e) {
      if (this.pagination_hasNextPage) this.getCaseMessages()
    },
    dragHandled(isDragged) {
      this.isActive = isDragged
    },
    dropHandled(event) {
      if (!event.dataTransfer.files[0]) return

      this.isActive = false
      const url = URL.createObjectURL(event.dataTransfer.files[0])

      if (url) {
        event.dataTransfer.files[0].src = url

        this.pushFiles({
          type: 'image',
          src: event.dataTransfer.files[0].src,
          file: event.dataTransfer.files[0]
        })
      }
    },
    getCaseMessages () {
      this['case/messages']({
        case_id: this.$route.params.case_id,
        params: {
          ...this.paginationParams,
          event_types: this.selectedEventTypes,
          event_names: this.selectedEventNames
        },
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          this.parseResponseForPaginationData(res)
          this.$nextTick(() => {
            if (this.first_message_id) {
              const container = $('#messages-container')
              const message = $(`[_id=${this.first_message_id}]`).first()

              if (message && message.offset()) {
                container.scrollTop(message.offset().top - container.offset().top)
              }
            }
            this.first_message_id = this.case_messages[0] ? this.case_messages[0]._id : null
          })
        }
      })
    },
    insertEmoji (emoji) {
      this.message += emoji.native

      if (this.$breakpoint.smDown) this.show_emojis = false
    },
    getFileName (file) {
      const field = file.url || file.src

      if (!field) return NAME_FILE_NOT_AVAILABLE

      try {
        return decodeURIComponent(field.match(/\.com\/.+\.\w{3,4}/gmi)[0].split('/').slice(-1)[0])
      } catch (error) {
        return console.log(NAME_FILE_NOT_AVAILABLE, error.message)
      }
    },
    getLastMessage () {
      if (this.case_messages.length) {
        try {
          const userLastMessage = this.case_messages.findLast((element) => element.author === 'user')

          if (userLastMessage) {
            const minutesPassed = this.$moment().diff(this.$moment(userLastMessage.date), 'minutes')

            if (minutesPassed <= 1) return userLastMessage

            return userLastMessage
          }

          return null
        } catch (error) {
          return null
        }
      }

      return {}
    },
    clearMessages () {
      this.$store.commit('case/setMessages', [])
    },
    updateFiles (files) {
      this.files = files
    },
    pushFiles (files) {
      this.files.push(files)
    },
    removeFiles (index) {
      this.files.splice(index, 1)
    },
    async holdCase () {
      try {
        mixpanel.track('Case Composer: Hold Case', {
					account_id: this.$route.params.account_id,
					unique_id: this.getCurrentUser().email,
					admin_id: this.getCurrentUser().email_id,
					role_id: this.getCurrentUser().role_id
				});
        const response = await this.$bvModal.msgBoxConfirm('¿Deseas poner en espera el caso?', {
          title: 'Poner en espera el caso',
          okVariant: 'primary',
          okTitle: 'Poner en espera',
          cancelTitle: 'Cancelar'
        })

        mixpanel.track(`Case Composer: on_hold (${response ? 'OK' : 'CANCEL' })`, {
					account_id: this.$route.params.account_id,
					unique_id: this.getCurrentUser().email,
					admin_id: this.getCurrentUser().email_id,
					role_id: this.getCurrentUser().role_id
				});

        if (response) this.updateCase({ status: 'on_hold' })
      } catch (e) {
        console.error(e.message)
      }
    },
    clearCase() {
      this.first_message_id = undefined
      this.clearMessages()
      this.resetPagination()
      this.getCaseMessages()
    },
    updateCase (data) {
      const self = this
      self.$store.commit('case/updating')

      if(!data.status != "on_hold"){
        mixpanel.track(`Case Composer: ${data.status})`, {
					account_id: this.$route.params.account_id,
					unique_id: this.getCurrentUser().email,
					admin_id: this.getCurrentUser().email_id,
					role_id: this.getCurrentUser().role_id
				});
      }

      this['case/update']({
        case_id: self.$route.params.case_id,
        ...data,
        callback: res => {
          if (data.read !== undefined) self.$store.commit('case/updating', false)
          if (res.error) return self.$message.error(res.error)

          if (data.status === 'close') {
            this.$message.info('El caso ha sido cerrado')
            // this.clearCase()
            // self.$router.push({name: 'Cases'})
          }
        }
      })
    },
    openTagsModal () {
      EventBus.$emit('caseAction/trigger', 'case/tags')
    },
  },
  beforeUnmount() {
    this.clearCase()
    EventBus.$emit('hangUpCallWhenReset')
  },
  mounted () {
    this.clearMessages()
    this.getCaseMessages()
    this.getCase()

    try {
      document.title = this.dashboardTitle
    } catch (e) {}
  },
  watch: {
    isCallPanelOpen() {
      EventBus.$emit('putIsCallPanelOpen', this.isCallPanelOpen)
    },
    case_events_filters: {
      handler: function (value, oldValue) {
        mixpanel.track('Case Composer: Event Filters', {
          account_id: this.$route.params.account_id,
          unique_id: this.getCurrentUser().email,
          admin_id: this.getCurrentUser().email_id,
          role_id: this.getCurrentUser().role_id,
          event_names: value.event_names,
          event_types: value.event_types
        })
        this.clearMessages()
        this.resetPagination()
        this.getCaseMessages()
      },
      deep: true
    },
    responsesModal (value) {
      if (value == true) {
        this.getResponses()
      }
    },
    response_search (val) {
      this.response_pagination.page = 1
      this.responses_hasNextPage = false
      if (val) {
        this.searchResponse()
      } else {
        this.getResponses()
      }
    },
    case_object (value) {
      document.title = value ? `Caso ${this.case_object.case_id} - ${this.userName || 'Usuario'}` : ''
    }
  },
  components: {
    Avatar,
    ComposerInput,
    ConversationCart,
    ConversationOrders,
    ScrollDownButton,
    TimeLine
  }
}
</script>

<style lang="scss" scoped>
audio::-webkit-media-controls-panel {
  background-color: #edf2f9;
}

audio::-webkit-media-controls-current-time-display {
  font-size: 15px;
}

audio::-webkit-media-controls-time-remaining-display {
  font-size: 15px;
}

audio::-webkit-media-controls-play-button {
  background-color: rgba(183, 206, 255, 1);
  border-radius: 50px;
  padding: 15px;
}

audio::-webkit-media-controls-play-button:hover {
  background-color: #ccdcff;
}

#button-to-scroll-down {
  z-index: 1;
  padding: 11.5px;
}
.position {
  position: absolute;
  background: rgba(183, 206, 255, 0.3);
  z-index: 2;
  border: none;
  border-radius: 5px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  animation: fade-in 0.5s;
}

.position::before {
  content: url('../assets/icons/image.svg');
}

.position::after {
  content: "Arrastra tu imagen aquí";
  font-size: 22px !important;
  color: #6C757D;
  border-radius: 6px;
  padding: 6px 10px;
  background-color: rgba(246, 246, 249, 1);
}

.active-position {
  background: rgba(183, 206, 255, 0.5);
}

.attachments-area {
  width: 100%;
  height: 70px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
}

.attachment-holder {
  padding: 10px;
  border-radius: 5px;
  margin: 5px;

  img {
    object-fit: cover !important;
  }
}
.date-tag {
  padding: 5px 15px;
  border-radius: 15px;
}

.index {
  z-index: 999;
}
.text {
  font-size: 12px;
  font-weight: lighter;
}

.margin {
  margin: 0px auto;
}
.call {
  z-index: 999;
  width: 101.7% !important;
  position: absolute;
  left: -10px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  background-color: rgba(48, 49, 53, 0.95);
}

.receiveCall {
  z-index: 999;
  width: 250px;
  position: absolute;
  top: 10px;
  font-size: 15px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  background-color: rgba(48, 49, 53, 0.95);
}

.buttonStyle {
  border-radius: 200px;
  height: 40px;
  width: 40px;
  border: none;
}

.pulser {
  animation: pulse 0.4s infinite alternate;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1.1);
  }
}

@keyframes fade-in {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
</style>
